import React from 'react'
import cn from 'classnames'
import st from './index.scss'
import { Button } from '@/components'

/**
 * 2022-11-12
 * @param {dataList} type == Array {title: 显示的值, value: 反馈给你的值（同时和model对比来判断是否选中）}
 * @param {model} 当前选中的值 
 * @param {change} 回调函数
 * @returns 
 */

export default function TopTypeBar({ dataList, model, change, className, ...props }) {
    return (
        <div className={cn(st['tabs-box'], className)} {...props}>
            <div className={st['tabs']}>
                {dataList?.length
                    ? dataList.map((item, key) => (
                        <Button
                            key={key}
                            size="small"
                            active={item.value == model}
                            onClick={()=>change(item.value)}
                        >{item?.title}</Button>
                    ))
                    : ''}
            </div>
        </div>
    )
}

{/* <div
    key={key}
    className={cn(st['tabs-item'], {
        [st['tab-item-active']]: item.value == model
    })}
    onClick={()=>change(item.value)}
>
    {item?.title}
</div> */}
